import {css} from "lit";
import {commonStyles} from "../../common/styles/Common.js";

export const labeledTextInputStyles = [commonStyles, css`
	label {
		display: block;
		font-size: 12px;
		font-weight: 500;
		color: var(--pn-label-text-color);
		line-height: 17px;
		letter-spacing: 0;
		margin-bottom: 20px;
	}

	label.is-bold {
		font-weight: bolder;
	}

	label .error-message {
		float: right;
		color: var(--pn-error-msg-light-bg-color);
	}

	label input {
		height: 40px;
	}

	input:not([type="checkbox"]), textarea {
		display: block;
		width: 100%;
		border: 1px solid var(--pn-input-border-color);
		border-radius: 6px;
		padding: 12px;
		font-weight: 500;
		font-size: 14px;
		line-height: 17px;
		color: var(--pn-input-text-color);
		box-sizing: border-box;
	}

	input:not([type="checkbox"]):read-only, textarea:read-only {
		border: 1px solid var(--pn-input-border-color);
		background-color: var(--pn-gray-light);
	}

	input:not([type="checkbox"]):hover, textarea:hover,
	input:not([type="checkbox"]):focus, textarea:focus {
		outline: none;
		border: 1px solid var(--pn-input-border-color-focus);
	}

	input:not([type="checkbox"]).error:hover, textarea.error:hover,
	input:not([type="checkbox"]).error:focus, textarea.error:focus,
	input:not([type="checkbox"]).aa-error:hover, textarea.aa-error:hover,
	input:not([type="checkbox"]).aa-error:focus, textarea.aa-error:focus {
		border-color: var(--pn-error-msg-light-bg-color);
	}
`];
